import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';
import { HttpClientModule } from '@angular/common/http';
import { RealPipe } from '../pipe/money';

import { Variables } from '../providers/variables';
import { LocalStorageService } from '../providers/localstorage';
import { LoginService } from '../providers/login';
import { AboutService } from '../providers/about';
import { ChampionshipService } from '../providers/championship';
import { UserService } from '../providers/user';
import { ContestService } from '../providers/contest';


import { MyApp } from './app.component';
import { HomePage } from '../pages/home/home';
import { LoginPage } from '../pages/login/login';
import { AboutPage } from '../pages/about/about';
import { NewTicketPage } from '../pages/newticket/newticket';
import { BetPage } from '../pages/contest/bet';
import { GamePage } from '../pages/contest/game';
import { StatmentPage } from '../pages/contest/statment';
import { PaymentPage } from '../pages/about/payment';
import { RankPage } from '../pages/contest/rank';
import { TicketGroupPage } from '../pages/contest/ticketgroup2';
import { WhatsAppPage } from '../pages/about/whatsapp';

@NgModule({
  declarations: [
    MyApp,
    HomePage,
    LoginPage,
    AboutPage,
    NewTicketPage,
    RealPipe,
    BetPage,
    PaymentPage,
    GamePage,
    RankPage,
    TicketGroupPage,
    StatmentPage,
    WhatsAppPage
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    IonicModule.forRoot(MyApp)
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    HomePage,
    LoginPage,
    AboutPage,
    NewTicketPage,
    BetPage,
    PaymentPage,
    GamePage,
    RankPage,
    TicketGroupPage,
    StatmentPage,
    WhatsAppPage
  ],
  providers: [
    StatusBar,
    SplashScreen,
    LoginService,
    AboutService,
    ContestService,
    LocalStorageService,
    ChampionshipService,
    UserService,
    Variables,
    {provide: ErrorHandler, useClass: IonicErrorHandler} 
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts